module.exports = __webpack_public_path__ + "img/Penny-Tote-07.405c1ca9.jpg";